import { ZetaSection, ZetaGroup } from '../zeta-widget';

export function MemberAppListPage(props) {
  return (<ZetaSection title="รายชื่อโปรแกรมทั้งหมด">
  <ZetaGroup size="full">
    <div className="card-deck">
      <div className="card">
        <img src="https://www.crksolution.com/images/work-cube-01.png" className="card-img-top" alt="..." />
        <div className="card-body">
          <h5 className="card-title">Work Cube</h5>
          <p className="card-text">โปรแกรม ควบคุมการผลิต สำหรับโรงงานขนาดเล็ก
            ใช้สั่งผลิต และ บันทึกข้อมูลการผลิต
          </p>
          <p className="card-text"><small className="text-muted">99 บาท / เดือน</small></p>
          <a href="http://work.store.crksolution.com" className="btn btn-info btn-sm" target="_blank" rel="noreferrer">เปิดใช้งาน</a>
        </div>
      </div>
      <div className="card">
        <img src="https://www.crksolution.com/images/factory-cube-01.png" className="card-img-top" alt="..." />
        <div className="card-body">
          <h5 className="card-title">Factory Cube</h5>
          <p className="card-text">โปรแกรม คุมโรงงาน สำหรับโรงงานขนาดกลาง</p>
          <p className="card-text"><small className="text-muted">เริ่มให้บริการ มี.ค. 2565</small></p>
        </div>
      </div>
      <div className="card">
        <img src="https://www.crksolution.com/images/bill-cube-01.png" className="card-img-top" alt="..." />
        <div className="card-body">
          <h5 className="card-title">Bill Cube</h5>
          <p className="card-text">โปรแกรม พิมพ์บิลขาย บิลส่งของ สำหรับ ร้านค้าขนาดเล็ก</p>
          <p className="card-text"><small className="text-muted">เริ่มให้บริการ พ.ค. 2565</small></p>
        </div>
      </div>
    </div>     
  </ZetaGroup>
  </ZetaSection>)
}